import { render, staticRenderFns } from "./RealtimeNotifications.vue?vue&type=template&id=1f30f310&scoped=true"
import script from "./RealtimeNotifications.vue?vue&type=script&lang=js"
export * from "./RealtimeNotifications.vue?vue&type=script&lang=js"
import style0 from "./RealtimeNotifications.vue?vue&type=style&index=0&id=1f30f310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f30f310",
  null
  
)

export default component.exports